/**
 * 用于跨子域的localstorage操作
 * 父页面中使用
 * https://github.com/ofirdagan/cross-domain-local-storage
 */

var MESSAGE_NAMESPACE = 'cross-domain-local-message';
var options = {
    iframeId: 'cross-domain-iframe',
    iframeUrl: undefined,
    initCallback: function() {}
};
var requestId = -1;
var iframe;
var requests = {};
var wasInit = false;
var iframeReady = true;

function extend(object, defaultObject) {
    var result = defaultObject || {};
    var key;
    for (key in object) {
        if (object.hasOwnProperty(key)) {
            result[key] = object[key];
        }
    }
    return result;
}

function applyCallback(data) {
    if (requests[data.id]) {
        requests[data.id](data);
        delete requests[data.id];
    }
}

function receiveMessage(event) {
    var origin = event.origin;
    var reg = /(\.|^)qq\.com$/;

    if (!reg.test(origin)) {
        return;
    }


    var data;
    try {
        data = JSON.parse(event.data);
    } catch (err) {
        // 不是我们的消息，忽略之
    }
    if (data && data.namespace === MESSAGE_NAMESPACE) {
        if (data.id === 'iframe-ready') {
            iframeReady = true;
            options.initCallback();
        } else {
            applyCallback(data);
        }
    }
}

function buildMessage(action, key, value, callback) {
    requestId++;
    requests[requestId] = callback;
    var data = {
        namespace: MESSAGE_NAMESPACE,
        id: requestId,
        action: action,
        key: key,
        value: value
    };

    iframe.contentWindow.postMessage(JSON.stringify(data), '*');
}

function init(customOptions) {
    options = extend(customOptions, options);
    var temp = document.createElement('div');

    if (window.addEventListener) {
        window.addEventListener('message', receiveMessage, false);
    } else {
        window.attachEvent('onmessage', receiveMessage);
    }

    temp.innerHTML = '<iframe id="' + options.iframeId + '" src=' + options.iframeUrl + ' style="display: none;"></iframe>';
    document.body.appendChild(temp);
    iframe = document.getElementById(options.iframeId);
}

function isApiReady() {
    if (!wasInit) {
        console.log('需要先执行 init() 方法再使用.');
        return false;
    }
    if (!iframeReady) {
        console.log('需要等iframe ready后才能进行操作.');
        return false;
    }
    return true;
}

module.exports = {
    init: function(customOptions) {
        if (!customOptions.iframeUrl) {
            throw '必须指定iframe的url';
        }
        if (wasInit) {
            console.log('已经初始化过了');
            return;
        }
        wasInit = true;
        if (document.readyState === 'complete') {
            init(customOptions);
        } else {
            window.onload = function() {
                init(customOptions);
            };
        }
    },
    set: function(key, value, callback) {
        if (!isApiReady()) {
            return;
        }
        buildMessage('set', key, value, callback);
    },

    get: function(key, callback) {
        if (!isApiReady()) {
            return;
        }
        buildMessage('get', key, null, callback);
    },
    remove: function(key, callback) {
        if (!isApiReady()) {
            return;
        }
        buildMessage('remove', key, null, callback);
    },
    clear: function(callback) {
        if (!isApiReady()) {
            return;
        }
        buildMessage('clear', null, null, callback);
    },
    filter: function(reg, callback) {
        if (!isApiReady()) {
            return;
        }

        var regStr = reg.toString().replace(/(^\/)|(\/$)/g, '');

        buildMessage('filter', regStr, null, callback);
    },
    wasInit: function() {
        return wasInit;
    }
};
